import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import GlassCard from '../../../ui/glass/components/GlassCard';

const ServiceHistoryCard = ({ serviceHistory }) => {
    const navigate = useNavigate();

    return (
        <GlassCard sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Servis Geçmişi ({serviceHistory.length})</Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Tarih</TableCell>
                            <TableCell>Cihaz</TableCell>
                            <TableCell>Durum</TableCell>
                            <TableCell align="right">Tutar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {serviceHistory.map(r => (
                            <TableRow hover key={r.id} onClick={() => navigate(`/servis-kaydi/${r.id}`)} sx={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer', transition: 'background-color 0.2s' }}>
                                <TableCell>{r.olusturmaTarihi?.toDate().toLocaleDateString('tr-TR')}</TableCell>
                                <TableCell>{r.cihazSeriNumarasi}</TableCell>
                                <TableCell>{r.durum}</TableCell>
                                <TableCell align="right">
                                    {(r.toplamTutar || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </GlassCard>
    );
};

export default ServiceHistoryCard;
